import { render, staticRenderFns } from "./BudgetReportList.vue?vue&type=template&id=b353413a&scoped=true&"
import script from "./BudgetReportList.vue?vue&type=script&lang=js&"
export * from "./BudgetReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b353413a",
  null
  
)

export default component.exports